"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinner = exports.StyledImage = exports.StyledIcon = exports.Picture = exports.LegacyImage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var formatPosition = function formatPosition(props) {
  return "\n  ".concat(props.objectPositionX * 100, "%\n  ").concat(props.objectPositionY * 100, "%\n");
};
var Picture = exports.Picture = _styledComponents["default"].div.attrs(function (p) {
  return {
    style: {
      background: p.backgroundColor
    }
  };
}).withConfig({
  displayName: "styles__Picture",
  componentId: "sc-3j9wb0-0"
})(["overflow:hidden;position:relative;"]);
var BaseImage = _styledComponents["default"].div.withConfig({
  displayName: "styles__BaseImage",
  componentId: "sc-3j9wb0-1"
})(["height:100%;width:100%;", ""], function (p) {
  return p.isTransparent ? "\n    opacity: 0;\n  " : "\n    opacity: 1;\n    transition: 0.5s opacity ease-out;\n  ";
});
var StyledImage = exports.StyledImage = (0, _styledComponents["default"])(BaseImage.withComponent('img')).attrs(function (p) {
  return {
    style: {
      objectPosition: formatPosition(p)
    }
  };
}).withConfig({
  displayName: "styles__StyledImage",
  componentId: "sc-3j9wb0-2"
})(["display:", ";object-fit:", ";"], function (p) {
  return p.isHidden ? 'none' : 'block';
}, function (p) {
  return p.objectFit;
});
var LegacyImage = exports.LegacyImage = (0, _styledComponents["default"])(BaseImage).attrs(function (p) {
  return {
    style: {
      backgroundImage: p.src ? "url(\"".concat(p.src, "\")") : 'none',
      backgroundPosition: formatPosition(p)
    }
  };
}).withConfig({
  displayName: "styles__LegacyImage",
  componentId: "sc-3j9wb0-3"
})(["background-repeat:no-repeat;background-size:", ";"], function (p) {
  return p.objectFit;
});
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-3j9wb0-4"
})(["left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);"]);
var StyledSpinner = exports.StyledSpinner = StyledIcon.withComponent(_Spinner["default"]);
//# sourceMappingURL=styles.js.map